module.exports = __webpack_public_path__ + "img/img-email-sent.519fcb9c.png";